import { useNavigate, useSearchParams } from "react-router-dom";
import BrandHeader from "@/components/BrandHeader";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get("order_id");

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <BrandHeader />
      <main className="max-w-2xl mx-auto px-6 py-24 text-center">
        <XCircle className="w-16 h-16 text-amber-400 mx-auto mb-6" />
        <div className="text-xs uppercase tracking-[0.35em] text-amber-400 font-mono-display mb-3">
          Pago cancelado
        </div>
        <h1 className="font-display font-black text-4xl mb-3">Tu pago con tarjeta fue cancelado</h1>
        <p className="text-zinc-400 mb-10">
          No se te cobró. Puedes intentarlo de nuevo o elegir pagar por Zelle.
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Button
            onClick={() => navigate("/")}
            data-testid="retry-order-btn"
            className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold"
          >
            <ArrowLeft className="w-4 h-4 mr-1.5" /> Nuevo pedido
          </Button>
          {orderId && (
            <Button
              variant="outline"
              onClick={() => navigate(`/order/${orderId}`)}
              data-testid="continue-zelle-btn"
              className="border-white/10 bg-transparent text-zinc-300 hover:bg-white/5"
            >
              Ver mi orden
            </Button>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
